module.exports = __webpack_public_path__ + "static/media/parents.3cfc6f14.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/parents.svg
// module id = 1010
// module chunks = 0